import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8e83c2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-container w-100" }
const _hoisted_2 = {
  key: 0,
  class: "text-red"
}

import { ref, computed, onMounted } from "vue";
import { zipCodeRule, requiredRule } from "@/utils/rules";


export default /*#__PURE__*/_defineComponent({
  __name: 'ZipCodeInput',
  props: {
    modelValue: {},
    label: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;




const value = ref(props.modelValue);

const enforceZipCodeFormat = () => {
  if (!value.value) return;
  let formattedZip = value.value.replace(/\D/g, "").slice(0, 9); // Remove non-numeric characters and limit to 9 digits
  if (formattedZip.length > 5) {
    formattedZip = formattedZip.slice(0, 5) + "-" + formattedZip.slice(5); // Add dash after the 5th digit
  }
  value.value = formattedZip;
};

onMounted(() => {
  enforceZipCodeFormat();
});

const computedValue = computed({
  get: () => value.value,
  set: (newValue) => {
    value.value = newValue;
    emit("update:modelValue", newValue);
  },
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_input = _resolveComponent("v-input")!

  return (_openBlock(), _createBlock(_component_v_input, {
    "data-test": "zip-code-input",
    variant: "outlined",
    modelValue: computedValue.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((computedValue).value = $event)),
    rules: [_unref(zipCodeRule), _unref(requiredRule)],
    onInput: enforceZipCodeFormat
  }, {
    default: _withCtx(({ isValid }) => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((computedValue).value = $event)),
          class: _normalizeClass(`w-100 px-2 bg-gray pb-1 pt-4 ${
            isValid.value === false ? 'error' : ''
          }`),
          required: ""
        }, null, 2), [
          [_vModelText, computedValue.value]
        ]),
        _createElementVNode("label", null, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    message: _withCtx(({ message }) => [
      _createVNode(_component_v_icon, {
        size: "12",
        class: "mdi mdi-alert-circle-outline"
      }),
      _createTextVNode(" " + _toDisplayString(message), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "rules"]))
}
}

})